<template>
  <RadioInputList
    :id="$attrs.id || 'incomeSource'"
    :key="$attrs.key || 'incomeSource'"
    v-bind="$attrs"
    :title="$attrs.title || 'Modalidade de trabalho'"
    :options="$attrs.options || incomeSourceOptions"
    :searchable="false"
    @input="$emit('input', $event)"
  />
</template>
<script>
import { IncomeSourceOptions } from '@/helpers/persona'
import RadioInputList from '@/components/ui/newComponents/RadioInputList.vue'
export default {
  name: 'IncomeSourceRadioList',
  components: {
    RadioInputList,
  },
  inheritAttrs: false,
  emits: ['input'],
  computed: {
    incomeSourceOptions() {
      return IncomeSourceOptions.map((ed) => ({
        label: ed.name,
        description: ed.description,
        value: ed.value,
        id: ed.value,
      }))
    },
  },
}
</script>
<style lang="scss"></style>
